function FinishIcon({ color = 'currentColor', ...props }) {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M14 16.2857C14 16.2857 14.75 15.5714 17 15.5714C19.25 15.5714 20.75 17 23 17C25.25 17 26 16.2857 26 16.2857V7.71429C26 7.71429 25.25 8.42857 23 8.42857C20.75 8.42857 19.25 7 17 7C14.75 7 14 7.71429 14 7.71429V16.2857Z"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <path d="M14 18.9999V16.0999" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <path d="M16.5987 19C16.8539 19.2942 17 19.6357 17 20C17 21.1046 15.6569 22 14 22C12.3431 22 11 21.1046 11 20C11 19.6357 11.1461 19.2942 11.4013 19"
                stroke={color} strokeWidth="2" strokeLinecap="round" fill="none" />
            <rect x="17" y="8" width="2" height="2" fill={color} />
            <rect x="21" y="8" width="2" height="2" fill={color} />
            <rect x="17" y="12" width="2" height="2" fill={color} />
            <rect x="21" y="12" width="2" height="2" fill={color} />
            <rect x="23" y="10" width="2" height="2" fill={color} />
            <rect x="19" y="10" width="2" height="2" fill={color} />
            <rect x="15" y="10" width="2" height="2" fill={color} />
            <rect x="23" y="14" width="2" height="2" fill={color} />
            <rect x="19" y="14" width="2" height="2" fill={color} />
            <rect x="15" y="14" width="2" height="2" fill={color} />
            <circle cx="8" cy="20" r="1" fill={color} />
            <circle cx="5" cy="20" r="1" fill={color} />
        </svg>
    );
}

export default FinishIcon;